import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';

const { countryIsoCode = '' } = shopifyConst;

const SUPPORTED_COUNTRIES = ['DE'];

const DELIVERY_ADDRESS_MAP = {
  DE: {
    countryCode: 'DE',
  },
};

const isSupportedCountry = SUPPORTED_COUNTRIES.includes(countryIsoCode);

export const useIsEurope = () => isSupportedCountry;

export const useDeliveryAddress = () => {
  const address = DELIVERY_ADDRESS_MAP[countryIsoCode];

  if (!address) {
    return null;
  }

  return [
    {
      address: { deliveryAddress: address },
      selected: true,
      oneTimeUse: true,
      validationStrategy: "COUNTRY_CODE_ONLY"
    },
  ];
};